var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M.54 3.87.5 3a2 2 0 0 1 2-2H6.17a2 2 0 0 1 1.414.586l.829.828A2 2 0 0 0 9.828 3h3.982A2 2 0 0 1 15.8 5.181l-.636 7A2 2 0 0 1 13.173 14H2.826a2 2 0 0 1-1.992-1.819l-.636-7a2 2 0 0 1 .341-1.31M2.19 4a1 1 0 0 0-.996 1.09l.636 7a1 1 0 0 0 .996.91h10.347a1 1 0 0 0 .996-.91l.636-7A1 1 0 0 0 13.81 4zm4.688-1.707A1 1 0 0 0 6.171 2H2.5a1 1 0 0 0-1 .981l.006.139Q1.827 3 2.19 3h5.395z"
  })));
};
export default SvgFolder;